<template>
  <div :id="ID_FLIX_INPAGE" />
</template>

<script setup>
  import { insertFlixmedia } from '~~/common/utils/flix.js';

  const ID_FLIX_INPAGE = 'flix-inpage';
  const ID_FLIX_MINISITE = 'flix-minisite';

  const props = defineProps({
    productId: {
      type: Number,
      required: true,
    },
    eanCode: {
      type: String,
      required: true,
    },
  });

  insertFlixmedia({
    productId: props.productId,
    eanCode: props.eanCode,
    idFlixMinisite: ID_FLIX_MINISITE,
    idFlixInpage: ID_FLIX_INPAGE,
  });
</script>
